import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MDBBtn } from "mdbreact";
import { Beat } from "../../../../redux/reducers/spinner";
import { cleanInput } from "../../../../redux/helpers";
import { adminActions } from "../../../../redux/actions";
import PrimaryLoader from "../../../includes/Loaders/PrimaryLoader";

export default function EnhancedApplicationSettings() {
  const dispatch = useDispatch();
  let user = JSON.parse(localStorage.getItem("user"));
  let teamId = JSON.parse(localStorage.getItem("teamId"));
  const company_id = user?.data?.groups[teamId]?.company_id;

  const {
    updatingSettings,
    loadingSettings,
    loadingCurrency,
    allCurrencies,
    companySettings,
  } = useSelector((state) => state.admin);

  const [data, setData] = useState({
    automatic_assignment: companySettings?.automatic_assignment,
    base_fee: companySettings?.base_fee,
    base_fee_per_meter: companySettings?.base_fee_per_meter,
    base_fees_by_location: companySettings?.base_fees_by_location,
    base_fees_per_kilogram: companySettings?.base_fees_per_kilogram,
    currency: companySettings?.currency,
    discount_percentage: companySettings?.discount_percentage,
    insurance_percentage: companySettings?.insurance_percentage,
    fee_per_meter_checkout: companySettings?.fee_per_meter_checkout,
    order_checkout: companySettings?.order_checkout,
    service_area_checkout: companySettings?.service_area_checkout,
    tax_percentage: companySettings?.tax_percentage,
    vat_percentage: companySettings?.vat_percentage,
    weight_limit_by_kilogram: companySettings?.weight_limit_by_kilogram,
  });

  useEffect(() => {
    dispatch(adminActions.getApplicationSettings());
    dispatch(adminActions.getAllCurrencies());
    dispatch(adminActions.getACompanySettings(company_id));
  }, [dispatch, company_id]);

  useEffect(() => {
    if (companySettings) {
      setData({
        automatic_assignment: companySettings?.automatic_assignment,
        base_fee: companySettings?.base_fee,
        base_fee_per_meter: companySettings?.base_fee_per_meter,
        base_fees_by_location: companySettings?.base_fees_by_location,
        base_fees_per_kilogram: companySettings?.base_fees_per_kilogram,
        currency: companySettings?.currency,
        discount_percentage: companySettings?.discount_percentage,
        insurance_percentage: companySettings?.insurance_percentage,
        fee_per_meter_checkout: companySettings?.fee_per_meter_checkout,
        order_checkout: companySettings?.order_checkout,
        service_area_checkout: companySettings?.service_area_checkout,
        tax_percentage: companySettings?.tax_percentage,
        vat_percentage: companySettings?.vat_percentage,
        weight_limit_by_kilogram: companySettings?.weight_limit_by_kilogram,
      });
    }
  }, [companySettings]);

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;

    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdate = async () => {
    cleanInput(data);
    const response = dispatch(adminActions.updateCompanySettings({ ...data }));
    if (response.status === "success") {
      dispatch(adminActions.getACompanySettings(company_id));
    }
  };

  return (
    <>
      {loadingSettings ? (
        <PrimaryLoader />
      ) : (
        <>
          <div className="w-100 mx-auto">
            <div className="mx-auto bg-white dark:bg-[#121212] sm:w-[630px] w-full mt-10 sm:mt-0 sm:border p-6 sm:border-gray-200 dark:border-none">
              <div className="border-b-2 dark:border-[#505050] py-4 mb-6">
                <p className=" text-base font-medium text-gray-800 dark:text-white flex justify-center ">
                  Update Company Settings
                </p>
              </div>

              <form>
                <div className=" sm:px-10 mb-10">
                  <div className="row">
                    <div className={"form-group col-md-12 mb-4"}>
                      <label htmlFor="automatic_assignment">
                        Automatic assignment
                      </label>
                      <select
                        className="form-control"
                        name="automatic_assignment"
                        value={data?.automatic_assignment}
                        onChange={handleChange}
                      >
                        <option>Select option</option>
                        <option value={true}>True</option>
                        <option value={false}>False</option>
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className={"form-group col-md-6 mb-4"}>
                      <label htmlFor="base_fee">Base Fee</label>
                      <input
                        type="text"
                        className="form-control"
                        name="base_fee"
                        onChange={handleChange}
                        value={data?.base_fee}
                        placeholder={"0.0"}
                      />
                    </div>
                    <div className={"form-group col-md-6 mb-4"}>
                      <label htmlFor="base_fee_per_meter">
                        Base fee per meter
                      </label>
                      <select
                        className="form-control"
                        name="base_fee_per_meter"
                        value={data?.base_fee_per_meter}
                        onChange={handleChange}
                      >
                        <option>Select Status</option>
                        <option value={true}>True</option>
                        <option value={false}>False</option>
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className={"form-group col-md-6 mb-4"}>
                      <label htmlFor="base_fees_by_location">
                        Base fee by location
                      </label>
                      <select
                        className="form-control"
                        name="base_fees_by_location"
                        value={data?.base_fees_by_location}
                        onChange={handleChange}
                      >
                        <option>Select Status</option>
                        <option value={true}>True</option>
                        <option value={false}>False</option>
                      </select>
                    </div>

                    <div className={"form-group col-md-6 mb-4"}>
                      <label htmlFor="base_fees_per_kilogram">
                        Base fee per kilogram
                      </label>
                      <select
                        className="form-control"
                        name="base_fees_per_kilogram"
                        value={data?.base_fees_per_kilogram}
                        onChange={handleChange}
                      >
                        <option>Select Status</option>
                        <option value={true}>True</option>
                        <option value={false}>False</option>
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className={"form-group col-md-6 mb-4"}>
                      <label htmlFor="currency">Currency</label>
                      <select
                        className="form-control"
                        name="currency"
                        value={data?.currency || ""}
                        onChange={handleChange}
                      >
                        <option>Select Currency</option>
                        {loadingCurrency ? (
                          <option>Loading...</option>
                        ) : (
                          Object.keys(allCurrencies).map((key) => (
                            <option
                              key={allCurrencies[key]?.id}
                              value={allCurrencies[key]?.alphabetic_code}
                            >
                              {allCurrencies[key]?.alphabetic_code}
                            </option>
                          ))
                        )}
                      </select>
                    </div>

                    <div className={"form-group col-md-6 mb-4"}>
                      <label htmlFor="discount_percentage">
                        Discount percentage
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="discount_percentage"
                        onChange={handleChange}
                        value={data?.discount_percentage}
                        placeholder={"0.0"}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className={"form-group col-md-6 mb-4"}>
                      <label htmlFor="insurance_percentage">
                        Insurance percentage
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="insurance_percentage"
                        onChange={handleChange}
                        value={data?.insurance_percentage}
                        placeholder={"0.0"}
                      />
                    </div>

                    <div className={"form-group col-md-6 mb-4"}>
                      <label htmlFor="fee_per_meter_checkout">
                        Fee per meter checkout
                      </label>
                      <select
                        className="form-control"
                        name="fee_per_meter_checkout"
                        value={data?.fee_per_meter_checkout}
                        onChange={handleChange}
                      >
                        <option>Select Status</option>
                        <option value={true}>True</option>
                        <option value={false}>False</option>
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className={"form-group col-md-6 mb-4"}>
                      <label htmlFor="order_checkout">Order checkout</label>
                      <select
                        className="form-control"
                        name="order_checkout"
                        value={data?.order_checkout}
                        onChange={handleChange}
                      >
                        <option>Select Status</option>
                        <option value={true}>True</option>
                        <option value={false}>False</option>
                      </select>
                    </div>

                    <div className={"form-group col-md-6 mb-4"}>
                      <label htmlFor="service_area_checkout">
                        Service area checkout
                      </label>
                      <select
                        className="form-control"
                        name="service_area_checkout"
                        value={data?.service_area_checkout}
                        onChange={handleChange}
                      >
                        <option>Select Status</option>
                        <option value={true}>True</option>
                        <option value={false}>False</option>
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className={"form-group col-md-6 mb-4"}>
                      <label htmlFor="tax_percentage">Tax percentage</label>
                      <input
                        type="text"
                        className="form-control"
                        name="tax_percentage"
                        onChange={handleChange}
                        defaultValue={data?.tax_percentage}
                        placeholder={"0.0"}
                      />
                    </div>

                    <div className={"form-group col-md-6 mb-4"}>
                      <label htmlFor="vat_percentage">Vat percentage</label>
                      <input
                        type="text"
                        className="form-control"
                        name="vat_percentage"
                        onChange={handleChange}
                        defaultValue={data?.vat_percentage}
                        placeholder={"0.0"}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className={"form-group col-md-12 mb-4"}>
                      <label htmlFor="weight_limit_by_kilogram">
                        Weight limit by kilogram
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="weight_limit_by_kilogram"
                        onChange={handleChange}
                        defaultValue={data?.weight_limit_by_kilogram}
                        placeholder={"0.0"}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="flex justify-center mx-auto">
            <MDBBtn color="primary" type="button" onClick={handleUpdate}>
              {updatingSettings ? (
                <Beat loading={updatingSettings} />
              ) : (
                "Update Settings"
              )}
            </MDBBtn>
          </div>
        </>
      )}
    </>
  );
}
